module.exports = __webpack_public_path__ + "img/public/SiteIcons/InstagramIconBlack.svg?f74c5e5d";